export default __webpack_public_path__ + "static/media/guest.d78f23da.png";